import React, {useContext, useState} from 'react';
import { useAsyncEffect } from '../../../hooks/UseAsyncEffect';
import {CustomerContext} from "../CustomerContext";
import { formatCustomerName, toFormattedDate } from "../../../utilities/FormatHelpers";
import {useNavigate} from "react-router-dom";

export default function CustomerSummary() {
    const navigate = useNavigate();
    const {customerId, customerInformationService, setError} = useContext(CustomerContext);
    const [loading, setLoading] = useState(true as boolean);
    const [customer, setCustomer] = useState(undefined as any);

    useAsyncEffect(async () => {
        try{
            setLoading(true);
            const customer = await customerInformationService.getCustomerById(customerId);
            setLoading(false);
            setCustomer(customer);
        } catch (error) {
            setLoading(false);
            setError({source: 'Get Customer', ...error});
        }
    }, [customerId]);

    return (
        <div className="ui card">
            <div className="custom-card-header">Customer: {!loading && formatCustomerName(customer)}</div>
            <div className="content">
                {loading && <div className="ui active centered inline loader"/>}
                {!loading &&
                    <>
                        <div>Id: {customer.id}</div>
                        <div>External Id: {customer.externalId}</div>
                        <div>Date of Birth: {toFormattedDate(customer.dateOfBirth)}</div>
                        <button className="ui primary button" type="submit" onClick={() => navigate(`/customers/${customer.id}/update`)}>Edit</button>
                    </>}
            </div>
        </div>
    );
}